export default {
  props: {
    append: Boolean,
    disabled: Boolean,
    href: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    ripple: Boolean,
    router: Boolean,
    tag: String
  },

  methods: {
    click () {},
    generateRouteLink () {
      let tag

      const data = {
        attrs: {},
        class: this.classes,
        props: {},
        directives: [
          {
            name: 'ripple',
            value: this.ripple || false
          }
        ]
      }

      if (this.href && this.router) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link'
        data.props.to = this.href
        data.props.exact = this.href === '/'
        data.props.activeClass = this.activeClass
        data.props.append = this.append
        data.props.replace = this.replace
        data.nativeOn = { click: this.click }
      } else {
        tag = this.tag || 'a'
        data.attrs.href = this.href || 'javascript:;'
        data.on = { click: this.click }
      }

      return { tag, data }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/route-link.js